<template>
  <v-app-bar color="primary"  app>
    <v-img class="logo p-0 ms-0 " :src="logohorizontal" alt="Logo" max-width="200" @click="$router.push('/')"
      contain></v-img>

    <v-spacer></v-spacer>
    <!-- Tabs para desktop -->
    <!-- <v-tabs  v-model="tab" slider-color="transparent">
      <v-tab v-for="(item, i) in castellano ? itemsCAS : items" :key="i" v-bind="item.link.startsWith('http')
        ? { href: item.link, target: '_blank', rel: 'noopener noreferrer' }
        : { to: item.link }" :style="{ fontWeight: tab === i ? '1000' : '200' }"
        :class="{ 'language-tab': i === (castellano ? itemsCAS.length : items.length) - 1 }">

        {{ item.title }}
      </v-tab>
    </v-tabs> -->
  </v-app-bar>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'

import logohorizontal from '@/assets/logo-horizontal-zuria.svg'

const tab = ref(null)
const items = ref([
  { title: 'CAS', link: '/cas/zuentzat' },
])
const itemsCAS = ref([
  { title: 'EUS', link: '/zuentzat' },
])

const route = useRoute()
const castellano = computed(() => route.path.startsWith('/cas'))

const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth < 768 // breakpoint móvil
  console.log('isMobile:', isMobile.value)
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
const menuOpen = ref(false)
const toggleMenu = () => menuOpen.value = !menuOpen.value
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #222;
  color: white; */
  padding: 0.5rem 1rem;
}

.logo {
  cursor: pointer;
}

.custom-menu {
  min-width: 250px;
  /* ancho mínimo más grande */
  /* background-color: #1e1e2f; color de fondo */
  /* color: white; color del texto */
  /* border-radius: 12px; bordes redondeados opcionales */
  /* padding: 8px 0; */
}

.navbar .menu-icon {
  font-size: 2rem;
  cursor: pointer;
  display: none;
}

.navbar ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.navbar ul li {
  margin-left: 1rem;
}

.navbar ul li a {
  color: white;
  text-decoration: none;
}

@media (max-width: 768px) {
  .navbar .menu-icon {
    display: block;
  }

  .navbar ul {
    position: absolute;
    top: 60px;
    right: 0;
    background: #222;
    flex-direction: column;
    width: 200px;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }

  .navbar ul.open {
    transform: translateX(0);
  }

  .navbar ul li {
    margin: 1rem;
  }

  ::v-deep(.v-tab.v-tab--active) {
    font-weight: 700;
  }
}
</style>
